// Wraps text with <b></b> exclude text in curly brackets
export const wrapValue = (value: string): string => {
  if (typeof value !== 'string' || !value) {
    return ''
  }

  const text = `${value}`
  // Regex to match text outside of doubled curly brackets
  const regex = /(\{\{.+?\}\})/g

  const parts = text.split(regex)

  return parts
    .map((part) => {
      if ((part.startsWith('{{') && part.endsWith('}}')) || !part) {
        return part
      } else {
        return `<b>${part}</b>`
      }
    })
    .join('')
}
